<template>
  <div class="teacherManger">
    <!-- 校园树 -->
    <!-- <el-aside width="240px" style="padding-right:10px;overflow: auto;background: #fff;border-radius: 4px;">
        <div class='sidebar'>
          <div class='title'>校区</div>
          <tree @setIds="setIdEvent"></tree>
        </div>
    </el-aside>-->
    <!-- 表格主体 -->
    <el-card>
      <el-row :gutter="20" style="margin-bottom:10px;">
        <el-col :sm="12" :md="4" :lg="4">
          <el-select style="width: 100%;" v-model="searchForm.tableType" clearable placeholder="请选择类型级">
            <el-option label="请选择" value=""></el-option>
            <el-option label="落户政策" value="policy"></el-option>
            <el-option label="商品课程" value="goods"></el-option>
            <el-option label="新闻资讯" value="news"></el-option>
          </el-select>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4">
          <el-select style="width: 100%;" v-model="searchForm.sell" clearable placeholder="请选择状态">
            <el-option label="请选择" value=""></el-option>
            <el-option label="上架" value="1"></el-option>
            <el-option label="下架" value="2"></el-option>

          </el-select>
        </el-col>
        <el-col :sm="12" :md="10" :lg="10" style="display:flex">
          <el-input type="text" v-model="searchForm.name" placeholder="班级名称"></el-input>
          <el-button type="primary" @click="currentPage=1,getPageList()" icon="el-icon-search">查询</el-button>
          <el-button type="primary" @click="currentPage=1,getPageList()">导出</el-button>
        </el-col>
        <!-- <el-col :sm="12" :md="5" :lg="5" style="float:right">
          <el-button 
            type="primary"
            style="float:right"
            @click="showAddDialog = true;getSubjectTreeList()"
            icon="el-icon-plus"
          >添加教师</el-button>
        </el-col> -->
      </el-row>
      <el-row>

      </el-row>
    </el-card>
    <el-card class="box-card">
      <el-table v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" class="teacherTable" :data="tableData" border style="width: 100%;margin-top:20px;" prop="date">
        <!-- <el-table-column type="index" :index="indexMethod" label="排序" width="50"></el-table-column> -->
        <el-table-column prop="tableType" show-overflow-tooltip label="类型" width="100">
          <template slot-scope="scope">
            {{scope.row.tableType==1?'落户政策':(scope.row.tableType==2?'商品课程':'新闻资讯')}}
          </template>
        </el-table-column>
        <el-table-column prop="name" show-overflow-tooltip label="标题"></el-table-column>
        <el-table-column prop="img" label="封面海报" width="150">
          <template slot-scope="scope">
            <img :src="scope.row.img" style="width:100px;height:100px;" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="initViewNum" label="初始阅读" width="100" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="nowViewNum" label="实际阅读" width="100" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="initLikeNum" label="初始点赞" width="100" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="nowLikeNum" label="实际点赞" width="100" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="initCollectNum" label="初始收藏" width="100" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="nowCollectNum" label="实际收藏" width="100" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="state" label="状态" width="100" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div class="">
              {{scope.row.state==1?'上架':'下架'}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="courseName" label="操作" width="150">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span class="icon-style el-icon-edit" @click="editCourse(scope.row)"></span>
              <span class="icon-style el-icon-view" @click="viewDetail(scope.row)"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table_bottom">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" style="margin-top: 20px;text-align: left;" background layout="prev, pager, next, jumper,  total, sizes" :total="total" :page-size.sync="pageSize" :current-page.sync="currentPage"></el-pagination>
      </div>
    </el-card>
    <el-dialog title="编辑" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="80px" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="12" :lg="12" style="padding:0 40px 20px">
            <img :src="clickData.img" style="width:100%;height:100%;" alt="">
          </el-col>
          <el-col :sm="24" :md="12" :lg="12" style="padding:0 40px 20px 0">
            “接受”：接受爱的人离开，接受亲的人离世，接受喜欢的人无论如何也不喜欢自己，接受喜欢的人无论如何也不能在一起…以
            及接受自己的出身、相貌、天份。无论活多大，每一次在“接受”面前
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="初始阅读" prop="initViewNum">
              <el-input type="number" v-model="addForm.initViewNum" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="初始点赞" prop="initLikeNum">
              <el-input type="number" v-model="addForm.initLikeNum" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="初始收藏" prop="initCollectNum">
              <el-input type="number" v-model="addForm.initCollectNum" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addClassInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cmVisible: false,
      dialogVisible: false,
      addForm: {
        initViewNum: '',
        initLikeNum: '',
        initCollectNum: '',
      },
      addFormRules: {
        initViewNum: [{ required: true, message: "请输入", trigger: "change" }],
        initLikeNum: [{ required: true, message: "请输入", trigger: "change" }],
        initCollectNum: [{ required: true, message: "请输入", trigger: "change" }],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      ClassInfoTreeList: [],
      classOptions: [],
      CampusProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      fileAction: `${process.env.BASE_URL}/system/uploadFile`,
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreeList: [],
      treeData: [], //校区树
      propsxxx: {
        children: "children",
        label: "name"
      },
      tableData: [], //表格数据
      searchForm: {
        tableType: '',
        sell: '',
        name: '',
      },
      createTime: '',
      showAddDialog: false,
      showEditorDialog: false,
      addwidth: "60%",
      loading: false,
      campusId: "",
      searchCampusId: null,
      form: {
        campusId: null,
        account: "",
        name: "",
        headPic: "",
        enabled: 1,
        remark: "",
        detail: ""
      },
      editForm: [],
      id: "",
      pageSize: 10,
      currentPage: 1,
      total: 0, //总的数据数
      start: "",
      end: "",
      pageNumber: [
        {
          value: 10,
          label: 10
        },
        {
          value: 20,
          label: 20
        }
      ],
      clickData: {}
    };
  },
  components: {
  },
  methods: {
    editCourse (row) {
      this.clickData = row
      this.dialogVisible = true
      this.addForm.initViewNum = row.initViewNum
      this.addForm.initLikeNum = row.initLikeNum
      this.addForm.initCollectNum = row.initCollectNum
    },
    viewDetail (row) {
      this.$router.push(`/courseDataStatistic?id=${row.id}&tableType=${row.tableType}&tableId=${row.tableId}`)
    },
    addClassInfo () {
      console.log(this.addForm)
      this.$refs.addForm.validate(valid => {
        if (valid) {
          var params = {
            id: this.clickData.id,
            initViewNum: this.addForm.initViewNum,
            initLikeNum: this.addForm.initLikeNum,
            initCollectNum: this.addForm.initCollectNum,
          }
          this.api.classInfo.updateCommonDataStatistics(params).then(res => {
            if (res.success) {
              this.dialogVisible = false
              this.addForm.initViewNum = ''
              this.addForm.initLikeNum = ''
              this.addForm.initCollectNum = ''
              this.getPageList()
            }
          });
        }
      });
    },
    getSubjectTreeList () {
      // 获取课程
      this.api.getSubjectCourseTreeList().then(result => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              if (items.children.length != 0) {
                for (let itemss of items.children) {
                  delete itemss.children;
                }
              } else {
                // delete items.children;
              }
            }
          } else {
            // delete item.children;
          }
        }
        this.subjectTreeList = result.data;
      }).catch(error => {
        console.log(error);
      });
    },

    indexMethod (index) {
      return index + 1 + (this.currentPage - 1) * 10;
    },
    handleRemove (file, fileList) {
      // this.uploadList = fileList;
      // if (this.picUrl.length > 0) {
      //   for (let i = 0; i < this.picUrl.length; i++) {
      //     if (this.picUrl[i].uid == file.uid) {
      //       this.picUrl.splice(i, 1);
      //     }
      //   }
      // }
    },
    handleChange (file, fileList) {
      // this.picUrl = fileList.slice(-1);
    },
    beforeUpload (file) {
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    UploadSuccess (res, file, fileList, val) {
      if (this.showEditorDialog) {
        this.form.headPic = res.data;
        console.log("22222", this.form.headPic);
      } else if (this.showAddDialog) {
        this.form.headPic = res.data;
        console.log("233333333", this.form.headPic);
      }
      // this.picUrl.push({
      //   name: res.data[0].FileName,
      //   url: res.data[0].FilePath
      // });
    },
    sizeChange () {
      this.pageChange();
    },
    currentChange () {
      this.pageChange();
    },
    pageChange () {
      // //分页发生变化时
      // let data;
      // if (this.inp && !this.campusId) {
      //   data = {
      //     pageNumber: this.currentPage,
      //     pageSize: this.pageSize,
      //   };
      // } else {
      //   data = {
      //     pageNumber: this.currentPage,
      //     pageSize: this.pageSize,
      //   };
      // }
      // this.api.agentUserInfo.teacherPageList(data).then(result => {
      //   if (result.success) {
      //     this.loading = false;
      //     this.tableData = result.data.records;
      //   }
      // });
      this.getPageList()
    },
    paginationInit () {
      if (this.currentPage == 1 && this.total <= this.pageSize) {
        this.start = 1;
        this.end = this.total;
      } else if (this.currentPage * this.pageSize < this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.currentPage * this.pageSize;
      } else if (this.currentPage * this.pageSize >= this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.total;
      }
      console.log(this.start, this.end);
    },
    getPageList () {
      let data = {
        tableType: this.searchForm.tableType,
        sell: this.searchForm.sell,
        name: this.searchForm.name,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      this.loading = true;
      // console.log(data)
      this.api.classInfo.getClassLogDataList(data).then(result => {
        if (result.success) {
          this.tableData = result.data.records;
          for (let item of this.tableData) {
            item.enabled = String(item.enabled);
          }
          this.total = Number(result.data.total);
          this.paginationInit();
          this.loading = false;
        }
      });
    },

    // 重置
    resetaddForm () {
      this.$refs.addForm.resetFields();
    },

    clearForm () {
      this.form = {
        campusId: null,
        account: "",
        name: "",
        headPic: "",
        enabled: 1,
        remark: "",
        detail: ""
      };
    }
  },
  created () {
    this.getPageList();
  },
};
</script>

<style scoped>
.teacherManger {
}

.teacherManger .el-radio {
  margin-right: 10px;
}
.el-input--suffix .el-input__inner {
  padding-right: 20px;
}

.sidebar,
.sidebarRight {
  background: white;
  padding: 0 20px 20px 0;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.teacherManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}

.addDialog .el-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
}

.addDialog .dialogLeft {
  text-align: right;
  padding-right: 10px;
}

.addDialog .el-dialog__body {
  padding: 15px 20px !important;
}

.table_bottom {
  margin: 20px 0;
}
.upload-img {
  width: 80px;
  height: 80px;
}
.plan-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
}
</style>
<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}
.upload-div {
  display: flex;
  flex-direction: row;
  .upload-img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px solid rgb(238, 238, 238);
  }
  .upload-content {
    margin-left: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content-text {
      width: 80px;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
    }
    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/conmom/courseDefaultSet.vue